import { AnalyticsNames } from '../models/analytics-names';
import { Entity } from '../models/entity';
import { Screen } from '../models/screen';
import { sendEvent } from '../store/analytics';
import { write } from '../store/good-cop';

export function startPositiveEngagement(params: {
  screen: Screen;
  entity: Entity;
  id: string;
  page?: string;
  rowTitle?: string;
  rowNumber?: number;
  columnTitle?: string;
  columnNumber?: number;
  [additionalProperties: string]: unknown;
}): void {
  write(params);
  sendEvent(AnalyticsNames.PositiveEngagementStarted, params);
}
